<template>
	<div class="ai-poster-page">
		<!-- ✅ 原生手写导航条 完全匹配设计稿要求 无任何修改 -->
		<div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
			<!-- 返回按钮 48px*48px | 左侧20px | 垂直居中 | assets/back.svg -->
			<div class="back-btn" @click="onBack">
				<img src="@/assets/back.svg" class="back-icon" />
			</div>
			<!-- 标题 严格匹配字体/字号/行高/间距/颜色等所有样式要求 -->
			<div class="nav-title">AI海报</div>
		</div>

		<!-- 页面主体区域 预留占位 后续加表单内容直接写这里即可 -->
		<div class="page-body">
			<!-- 主题标题 -->
			<div class="topic-title"><img src="@/assets/star.svg" class="required-star" />主题</div>
			<!-- 主题枚举横向选中标签组 -->
			<div class="topic-tag-list">
				<div class="topic-tag-item" v-for="item in topicOptions" :key="item.value"
					:class="{ active: form.topicEnum === item.value }" @click="onSelectTopicOption(item)">
					{{ item.label }}
				</div>
			</div>
			<div class="custom-textarea topic-textarea">
				<van-field v-model="form.customTopic" type="textarea" rows="1" maxlength="30" show-word-limit
					:autosize="false" placeholder="请输入海报主题" :border="false" background="none" class="van-field-nostyle"
					@input="onCustomTopicInput" />
			</div>
			<div class="topic-title" style="margin-top:5.3333vw;"><img src="@/assets/star.svg"
					class="required-star" />风格</div>
			<!-- ✅ 新增：风格标签列表 - 标题下方16px，基于styleOptions生成 -->
			<div class="style-tag-list">
				<div class="style-tag-item" v-for="item in styleOptions" :key="item.value"
					:class="{ active: form.style === item.value }" @click="onSelectStyleOption(item)">
					<!-- 1. 背景图 最底层 -->
					<img :src="item.imgUrl" class="style-item-img" />
					<!-- 2. 顶部44px渐变div 承载文字 -->
					<div class="style-item-top-bar">
						<span class="style-item-text">{{ item.label }}</span>
					</div>
				</div>
			</div>

			<div class="title-with-btn">
				<div class="topic-title" style="margin-top:5.3333vw;margin-bottom:2.1333vw;"><img
						src="@/assets/star.svg" class="required-star" />文案</div>
				<!-- AI优化润色按钮 - 点击调用onAiRewrite方法 -->
				<div class="ai-rewrite-btn" @click="onAiRewrite">
					<img src="@/assets/rs.svg" class="rewrite-icon" />
					<span class="rewrite-text">AI润色</span>
				</div>
			</div>
			<!-- ✅ 新增：文案输入框 - 复用所有custom-textarea样式，仅改字数限制为100 -->
			<div class="custom-textarea message-textarea">
				<van-field v-model="form.message" type="textarea" rows="3" maxlength="100" show-word-limit
					:autosize="false" placeholder="请输入海报文案" :border="false" background="none"
					class="van-field-nostyle" />
			</div>

			<div class="topic-title no-star" style="margin-top:5.3333vw;margin-bottom:2.1333vw;">描述</div>
			<!-- ✅ 新增：文案输入框 - 复用所有custom-textarea样式，仅改字数限制为100 -->
			<div class="custom-textarea desc-textarea">
				<van-field v-model="form.description" type="textarea" rows="5" maxlength="500" show-word-limit
					:autosize="false" placeholder="请输入海报描述" :border="false" background="none"
					class="van-field-nostyle" />
			</div>

			<div class="topic-title no-star" style="margin-top:5.3333vw;margin-bottom:2.1333vw;">数量</div>

			<div class="btn-group">
				<div class="btn-item" v-for="item in buttonList" :key="item.value"
					:class="{ active: form.generateNum === item.value }" @click="form.generateNum = item.value">
					{{ item.label }}
				</div>
			</div>

			<div class="bottom-btn-wrapper">
				<div class="bottom-btn cancel-btn">取消</div>
				<div class="bottom-btn confirm-btn" @click="onGenerate">确定</div>
			</div>

		</div>
		<LackModal v-if="showLackTipModal"  @closeModal="closeModal"/>
	</div>
</template>

<script>
	// ✅ 保留所有接口导入 备用
	import {
		generalImage,
		generalRefineTxt
	} from "@/api/poster";
	import LackModal from "@/components/lackModal.vue";
	import {
		deviceEnv
	} from '@/utils/device.js';
	export default {
		name: "AiPosterPage",
		components: { LackModal },
		data() {
			return {
				// ✅ ✅ ✅ data内所有内容 100%完整保留 一个字段都没删 ✅ ✅ ✅
				form: {
					topicEnum: "",
					customTopic: '',
					style: "",
					message: "",
					description: "",
					generateNum: 1,
				},
				topicOptions: [{
						label: "喜报",
						value: "CONGRATULATIONS"
					},
					{
						label: "节日活动",
						value: "FESTIVAL"
					},
					{
						label: "企业宣传",
						value: "CORPORATE_PROMOTION"
					},
					{
						label: "产品推广",
						value: "PRODUCT_PROMOTION"
					},
					{
						label: "贺卡",
						value: "GREETING_CARD"
					},
					// {
					// 	label: "邀请函",
					// 	value: "INVITATION"
					// },
				],
				styleOptions: [{
						label: "简约",
						value: "minimalist",
						imgUrl: require('@/assets/jy.jpeg') // 简约对应图片
					},
					{
						label: "商务",
						value: "business",
						imgUrl: require('@/assets/sw2.png') // 商务对应图片
					},
					{
						label: "卡通",
						value: "cartoon",
						imgUrl: require('@/assets/kt.jpeg') // 卡通对应图片
					},
					{
						label: "写实",
						value: "realistic",
						imgUrl: require('@/assets/xs.jpeg') // 写实对应图片 ✅ 你指定的路径
					},
				],
				buttonList: [{
						label: "1",
						value: 1,
					},
					{
						label: "2",
						value: 2
					},
					{
						label: "3",
						value: 3
					},
					{
						label: "4",
						value: 4
					}
				],
				showTopicOptions: false,
				showStyleOptions: false,
				topicError: false,
				styleError: false,
				posterImage: "",
				showLackTipModal: false,
				isMiniProgram: false,
				currentPlatform: '',
			};
		},
		computed: {
			// ✅ 保留所有计算属性 备用
			topicPlaceholder() {
				return this.form.topicLabel || "请选择主题";
			},
			stylePlaceholder() {
				return this.form.styleLabel || "请选择海报风格";
			},
		},
		mounted() {
			this.isMiniProgram = deviceEnv.isWechatMiniProgram;
			document.title = "AI海报";
			this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
			// ✅ 保留所有监听事件 备用
			document.addEventListener("click", this.handleOutsideClick, true);
			const bodyEl = this.$el && this.$el.querySelector(".page-body");
			if (bodyEl) {
				bodyEl.addEventListener("scroll", this.handleScrollClose, {
					passive: true
				});
			}
		},
		beforeDestroy() {
			// ✅ 保留事件销毁逻辑 防止内存泄漏 备用
			document.removeEventListener("click", this.handleOutsideClick, true);
			const bodyEl = this.$el && this.$el.querySelector(".page-body");
			if (bodyEl) {
				bodyEl.removeEventListener("scroll", this.handleScrollClose);
			}
		},
		methods: {
			// ✅ 导航返回按钮点击事件
			onBack() {
				this.$router.back();
			},
			// ✅ AI文案改写接口方法 保留备用
			async onAiRewrite() {
				if (!this.form.message) {
					this.$toast && this.$toast("请先输入海报文案");
					return;
				}
				try {
					const res = await generalRefineTxt({
						message: this.form.message
					});
					this.form.message = res.message;
				} catch (error) {
					console.log(error);
				}
			},
			// ✅ 主题下拉框展开/收起 保留备用
			toggleTopicOptions() {
				this.showTopicOptions = !this.showTopicOptions;
				if (this.showTopicOptions) this.showStyleOptions = false;
			},
			// ✅ 风格下拉框展开/收起 保留备用
			toggleStyleOptions() {
				this.showStyleOptions = !this.showStyleOptions;
				if (this.showStyleOptions) this.showTopicOptions = false;
			},
			// ✅ 选择主题选项赋值 保留备用
			onSelectTopicOption(option) {
				this.form.topicEnum = option.value;
				this.form.topicLabel = option.label;
				this.form.customTopic = '';
				this.topicError = false;
				this.showTopicOptions = false;
			},
			onCustomTopicInput() {
				// 当自定义主题有非空内容时，清空选中的预设主题
				if (this.form.customTopic.trim()) {
					this.form.topicEnum = null; // 清空选中的主题枚举值
					this.form.topicLabel = ''; // 清空主题标签（保持数据一致性）
				}
			},
			// ✅ 选择风格选项赋值 保留备用
			onSelectStyleOption(option) {
				this.form.style = option.value;
				this.form.styleLabel = option.label;
				this.styleError = false;
				this.showStyleOptions = false;
			},
			// ✅ 核心 AI生成海报接口方法 完整保留 无删减 备用
			async onGenerate(values) {
				const hasTopic = this.form.topicEnum || (this.form.customTopic && this.form.customTopic.trim());
				// 2. 风格校验：必须选择
				const hasStyle = this.form.style && this.form.style.trim();
				// 3. 文案校验：必须输入
				const hasMessage = this.form.message && this.form.message.trim();

				// 校验提示
				if (!hasTopic) {
					this.$toast && this.$toast("请选择或输入主题");
					return;
				}
				if (!hasStyle) {
					this.$toast && this.$toast("请选择海报风格");
					return;
				}
				if (!hasMessage) {
					this.$toast && this.$toast("请输入海报文案");
					return;
				}
				const params = {
					message: this.form.message,
					style: this.form.style,
					topicEnum: this.form.topicEnum,
					customTopic: this.form.customTopic,
					refine: false,
					description: this.form.description,
					generateNum: this.form.generateNum
				};
				try {
					this.$toast.loading({
						message: '生成中...',
						forbidClick: true,
						duration: 0
					});
					const res = await generalImage(params);
					if(res?.status == 'notAllowed'){
            			this.showLackTipModal = true;
					} else if (res && res.urls) {
						this.$toast.clear();
						this.$toast.success('海报生成成功');
						this.$router.push({
							path: 'GeneratedPosterPage',
							query: {
								posterUrls: JSON.stringify(res.urls) // 数组转字符串传递
							}
						});
					} else {
						this.$toast.clear();
						this.$toast.fail('生成失败，请稍后重试');
					}
				} catch (error) {
					console.error('生成海报失败:', error);
					this.$toast.clear();
					this.$toast.fail('生成失败，请重试');
				}
			},
			// ✅ 重新生成海报 保留备用
			onRegenerate() {
				this.onGenerate();
			},
			closeModal(){
            	this.showLackTipModal = false;
			},
			// ✅ 海报下载功能 保留备用
			async onDownload() {
				if (!this.posterImage) {
					this.$toast && this.$toast("暂无海报可下载");
					return;
				}
				if(this.isMiniProgram){
					wx.miniProgram.navigateTo({
						//拼接url
						url:"/pages/webViewDownFile/index?filetype=img&fileUrl=" + encodeURIComponent(this.posterImage),
					});
					// window.parent.postMessage({
					// 		type: "BACK_TO_DOMN",
					// 		filetype: 'img',
					// 		fileUrl: encodeURIComponent(this.posterImage)
					// 	},
					// 	"*",
					// );
					return;
				}
				const link = document.createElement('a');
				link.href = this.posterImage;
				link.download = `poster-${Date.now()}.png`;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				this.$toast && this.$toast("开始下载海报");
			},
			// ✅ 海报预览功能 保留备用
			onPreviewPoster() {
				const ImagePreview = require('vant').ImagePreview;
				ImagePreview([this.posterImage]);
			},
			// ✅ 点击外部收起下拉框 保留备用
			handleOutsideClick(event) {
				const topicEl = this.$refs.topicBlock;
				const styleEl = this.$refs.styleBlock;
				const isInTopic = topicEl && topicEl.contains(event.target);
				const isInStyle = styleEl && styleEl.contains(event.target);
				if (!isInTopic) this.showTopicOptions = false;
				if (!isInStyle) this.showStyleOptions = false;
			},
			// ✅ 滚动收起下拉框 保留备用
			handleScrollClose() {
				this.showTopicOptions = false;
				this.showStyleOptions = false;
			},
		},
	};
</script>

<style scoped>
	/* 导航样式 不变 不用动 */
	.ai-poster-page {
		height: 100vh;
		height: 100dvh;
		width: 100vw;
		background: #f5f6f8;
		box-sizing: border-box;
		display: flex;
		/* ✅ 新增 */
		flex-direction: column;
		/* ✅ 新增：纵向排列 导航+主体 */
		overflow: hidden;
		position: fixed;
		/* 新增：固定定位，彻底锁定视口 */
		top: 0;
		left: 0;
	}

	.custom-nav-bar {
		width: 100vw;
		height: 11.7333vw;
		/* 高度翻倍的88px 不变 */
		background-image: linear-gradient(90deg, #E7F2FA 0%, #DBE2F1 100%);
		box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
		position: relative;
		/* ✅ 新增这1行 核心修复：让子元素absolute相对导航定位，按钮立刻飞回内部 */
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		flex-shrink: 0;
		overflow-y: auto;
		/* 纵向滚动 */
		overflow-x: hidden;
		/* 禁止横向滚动 */
		-webkit-overflow-scrolling: touch;
		/* 移动端顺滑滚动（关键） */
		/* 👇 隐藏滚动条（优化视觉，参考笔记页面） */
		scrollbar-width: none;
		/* 火狐 */
	}

	/* back-btn 样式完全不变，不用改，位置自动恢复左侧20px垂直居中 */
	.back-btn {
		width: 6.4vw;
		height: 6.4vw;
		position: absolute;
		left: 2.6667vw;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.back-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-title {
		font-family: SourceHanSansSC-Medium;
		font-size: 4.8vw;
		color: #000000;
		letter-spacing: 0.1333vw;
		text-align: center;
		line-height: 11.7333vw;
		font-weight: 500;
	}

	/* ✅ 主体样式 按你要求修改：左右36px 上下40px 白色背景 border-box */
	.page-body {
		padding: 5.3333vw 4.8vw;
		/* ✅ 上40px 下40px 左36px 右36px 完全不变，精准匹配你的要求 */
		box-sizing: border-box;
		background: #FFFFFF;
		/* ✅ 白色背景不变 */
		flex: 1;
		/* ✅ 核心新增：自动撑满 导航下方的全部剩余屏幕高度，永不留白 */
		min-height: 0;
		/* 兼容弹性布局，防止内容溢出 */
		overflow-y: auto;
		/* 纵向滚动 */
		overflow-x: hidden;
		/* 禁止横向滚动 */
		-webkit-overflow-scrolling: touch;
		/* 移动端顺滑滚动（关键） */
		/* 👇 隐藏滚动条（优化视觉，参考笔记页面） */
		scrollbar-width: none;
		/* 火狐 */
	}

	.page-body::-webkit-scrollbar {
		display: none;
	}

	/* ✅ 主题文字样式 1:1匹配你的要求 */
	.topic-title {
		display: flex;
		align-items: center;
		/* 父容器flex，确保图片+文字垂直居中 */
		opacity: 0.9;
		font-family: SourceHanSansSC-Bold;
		font-size: 4.2667vw;
		/* 40px */
		color: #1F2226;
		letter-spacing: 0;
		/* -0.96px */
		font-weight: 700;
		margin-bottom: 2.1333vw;
		/* 文字下方16px间距 */
	}

	/* ✅ 主题标签横向容器 横向排列 超出可滑动 gap: 1.6vw;*/
	.topic-tag-list {
		display: flex;
		align-items: center;
		gap: 1.57vw;
		/* 标签之间间距12px */
		flex-wrap: nowrap;
		overflow-x: auto;
		overflow-x: clip;
		padding-bottom: 1vw;
		scrollbar-width: none;
		margin-bottom: 2.1333vw;
	}

	.topic-tag-list::-webkit-scrollbar {
		display: none;
	}

	/* ✅ 标签默认样式 1:1匹配你的要求 */
	.topic-tag-item {
		width: auto;
		padding: 1.2667vw 2.4vw;
		/* 上下9.5px 左右18px 不变 */
		background: #EBEBED;
		/* 灰色背景 不变 */
		border-radius: 1.0667vw;
		/* 8px圆角 不变 */
		font-family: SourceHanSansSC-Regular;
		font-size: 2.6667vw;
		/* 20px字号 不变 */
		color: #666666;
		/* 灰色文字 不变 */
		text-align: center;
		font-weight: 400;
		box-sizing: border-box;
		white-space: nowrap;
		/* ✅ 核心修复：加和选中态同等宽度的透明边框，抵消宽度差，根治抖动 */
		border: 0.2667vw solid transparent;
	}

	/* ✅ 选中标签：样式完全不变！！！ 颜色/背景/边框都和你要求的一模一样 */
	.topic-tag-item.active {
		background: rgba(21, 112, 238, 0.10);
		border: 0.2667vw solid #1570EE;
		/* 2px蓝色边框 不变 */
		font-family: SourceHanSansSC-Regular;
		font-size: 2.6667vw;
		color: #1F2226;
		text-align: center;
		font-weight: 400;
	}

	/* 原有预览区样式 保留不动 */
	.preview-wrapper {
		margin-top: 2.6667vw;
	}

	.block-title {
		font-size: 3.2vw;
		color: #333333;
		margin-bottom: 2.1333vw;
	}

	.poster-card {
		background: #ffffff;
		border-radius: 1.6vw;
		overflow: hidden;
		box-shadow: 0 0.5333vw 1.6vw rgba(0, 0, 0, 0.04);
	}

	.poster-img {
		width: 100%;
		display: block;
	}

	.preview-actions {
		display: flex;
		justify-content: space-between;
		margin-top: 2.6667vw;
	}

	.action-btn {
		flex: 1;
		text-align: center;
		padding: 2.6667vw 0;
		border-radius: 1.6vw;
		font-size: 3.2vw;
		background: #f5f5f5;
		color: #333;
	}

	.action-btn.primary {
		background: #0065ff;
		color: #fff;
		margin-left: 2.6667vw;
	}

	.action-btn:active {
		opacity: 0.8;
	}

	.custom-textarea {
		width: 100%;
		border-radius: 2.1333vw !important;
		box-shadow: 0px 0px 1.3333vw 0px rgba(0, 0, 0, 0.18) !important;
		background: #FFFFFF !important;
		box-sizing: border-box !important;
		position: relative !important;
		padding: 1.6vw 2.1333vw !important;
		margin-bottom: 5.3333vw;
	}

	.topic-textarea {
		height: 13.3333vw !important;
		/* 100px = 100/7.5 = 13.3333vw */
	}

	/* 第二个输入框（文案）：高度160px */
	.message-textarea {
		height: 21.3333vw !important;
		/* 160px = 160/7.5 = 21.3333vw */
	}

	/* 第三个输入框（描述）：高度240px */
	.desc-textarea {
		height: 32vw !important;
		/* 240px = 240/7.5 = 32vw */
	}

	/* ✅ 核心：van-field 本身彻底清零所有样式，纯无样式状态 */
	.van-field-nostyle {
		width: 100% !important;
		height: 100% !important;
		background: transparent !important;
		border: none !important;
		outline: none !important;
		padding: 0 !important;
		margin: 0 !important;
		box-shadow: none !important;
		border-radius: 0 !important;
	}

	/* 清零field内部所有默认样式，textarea纯原生状态 */
	/deep/ .van-field__body {
		width: 100% !important;
		padding: 0 !important;
		margin: 0 !important;
		box-sizing: border-box !important;
	}

	/* 修复Vant坑点：彻底移除强制最小高度，防止溢出 */
	/deep/ .van-field--min-height .van-field__control {
		/* min-height: auto !important; */
	}

	/deep/ .van-field__control::placeholder {
		opacity: 0.4 !important;
		font-family: SourceHanSansSC-Regular !important;
		font-size: 3.2vw !important;
		/* 24px = 24/7.5 = 3.2vw */
		color: #333333 !important;
		letter-spacing: 0 !important;
		font-weight: 400 !important;
	}

	/* 兼容webkit内核浏览器 */
	/deep/ .van-field__control::-webkit-input-placeholder {
		opacity: 0.4 !important;
		font-family: SourceHanSansSC-Regular !important;
		font-size: 3.2vw !important;
		color: #333333 !important;
		letter-spacing: 0 !important;
		font-weight: 400 !important;
	}

	/* textarea文本域：纯无样式，rows="1"单行，禁止拉伸，基础字体配置 */
	/deep/ .van-field__control {
		width: 100% !important;
		background: transparent !important;
		border: none !important;
		outline: none !important;
		resize: none !important;
		/* 禁止手动拉伸 */
		font-family: SourceHanSansSC-Regular !important;
		font-size: 3.2vw !important;
		/* 输入文字20px */
		color: #1F2226 !important;
		line-height: 1.4 !important;
		padding: 0 !important;
		margin: 0 !important;
		letter-spacing: 0 !important;
	}

	/* ✅ 精准修改计数文字样式 1:1匹配你的所有要求 优先级拉满 */
	/deep/ .van-field__word-limit {
		opacity: 0.4 !important;
		font-family: SourceHanSansSC-Regular !important;
		font-size: 3.2vw !important;
		/* 24px = 24/7.5 = 3.2vw */
		color: rgba(31, 34, 38, 0.40) !important;
		letter-spacing: 0 !important;
		text-align: right !important;
		font-weight: 400 !important;
		position: absolute !important;
		right: 2.1333vw !important;
		/* 右侧16px 与输入框内边距对齐 */
		bottom: 0.6vw !important;
		/* 底部12px 与输入框内边距对齐 */
		z-index: 2 !important;
		margin: 0 !important;
	}

	.style-tag-list {
		display: flex;
		align-items: flex-start;
		gap: 1.6vw;
		flex-wrap: nowrap;
		flex-shrink: 0;
		overflow-x: auto;
		overflow-x: clip;
		padding-bottom: 1vw;
		scrollbar-width: none;
	}

	.style-tag-list::-webkit-scrollbar {
		display: none;
	}

	/* 风格选项：宽160px 高140px + 圆角16px + 和主题一致的选中态 无抖动 */
	.style-tag-item {
		width: 21.3333vw;
		/* 160px 宽 */
		height: 18.6667vw;
		/* 140px 高 */
		border-radius: 2.1333vw;
		/* 16px 圆角 */
		background: #EBEBED;
		box-sizing: border-box;
		flex-shrink: 0;
		position: relative;
		overflow: hidden !important;
		/* 防内容超圆角 */
		border: 0.2667vw solid transparent;
		/* 防抖动 必留 */
	}

	/* 背景图片：原有样式不变 */
	.style-item-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
		opacity: 0.9;
	}

	/* ✅ 顶部渐变div 原有样式不变 + 【新增1行 左对齐】 */
	.style-item-top-bar {
		width: 100%;
		height: 5.8667vw;
		/* 44px 高 精准值 */
		background-image: linear-gradient(105deg, #F0F4FF 0%, #F0F4FF 3%, #EEF9FF 100%);
		box-sizing: border-box;
		padding: 1vw 0.8vw;
		/* ✅ 上下7.5px 左右6px 不变 */
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		/* ✅ 核心新增：内部内容靠左排列 */
	}

	/* ✅ 文字样式 【核心新增1行 text-align:left 靠左展示】 + 基础样式 */
	.style-item-text {
		font-family: SourceHanSansSC-Regular;
		font-size: 2.6667vw;
		/* 20px 字号 */
		color: #666666;
		letter-spacing: 0;
		font-weight: 400;
		text-align: left;
		/* ✅ 文字靠左展示 生效 */
		line-height: 1.2;
	}

	/* ✅ 完整补全 风格选中态所有样式 无截断 1:1匹配你的全部要求 */
	.style-tag-item.active {
		background: rgba(21, 112, 238, 0.10);
		border: 0.2667vw solid #1570EE;
		/* 和主题一致的2px蓝色边框 */
	}

	/* ✅ 选中态文字 精准匹配你要求的所有样式：opacity0.8+指定字体+20px+#1570EE+靠左 */
	.style-tag-item.active .style-item-text {
		opacity: 0.8 !important;
		font-family: SourceHanSansSC-Medium !important;
		font-size: 2.6667vw !important;
		/* 20px */
		color: #1570EE !important;
		letter-spacing: 0 !important;
		text-align: left !important;
		/* 选中后依然靠左 */
		font-weight: 500 !important;
	}

	.btn-group {
		display: flex;
		align-items: center;
		gap: 1.6vw;
		/* 按钮间距 12px 精准vw */
		flex-wrap: nowrap;
		flex-shrink: 0;
		overflow-x: auto;
		overflow-x: clip;
		padding: 0.5333vw 0;
		scrollbar-width: none;
		margin-top: 2.1333vw;
		/* 标题下方16px 精准vw */
	}

	.btn-group::-webkit-scrollbar {
		display: none;
	}

	/* 单个按钮样式 - 1:1匹配所有要求 */
	.btn-item {
		width: 14.9333vw;
		/* 固定宽 112px 精准换算 */
		height: 5.6vw;
		/* 固定高 42px 精准换算 */
		border: 0.2667vw solid #D2DAE4;
		/* 2px 边框色 #D2DAE4 */
		border-radius: 1.0667vw;
		/* 圆角 8px 精准换算 */
		font-family: SourceHanSansSC-Medium;
		font-size: 2.6667vw;
		/* 字体大小 20px */
		color: #000000;
		text-align: center;
		font-weight: 500;
		box-sizing: border-box;
		flex-shrink: 0;
		/* 固定宽高 不被挤压变形 */
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 按钮选中态 - 样式完全照搬你的要求 一字不差 */
	.btn-item.active {
		background: rgba(21, 112, 238, 0.08);
		border: 0.2667vw solid #1570EE;
		/* 2px 边框色 #1570EE */
		border-radius: 1.0667vw;
	}

	.bottom-btn-wrapper {
		/* position: fixed;
		left: 50%; */
		/* bottom: 13.3333vw; */
		/* 精准 100px 距离屏幕底部 */
		/* transform: translateX(-50%); */
		/* 核心：让两个按钮整体水平居中 */
		margin-top: 5.7333vw;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 3.2vw;
		/* 按钮之间间距 精准 24px */
		/* z-index: 99; */
		/* 防止被其他内容遮挡，层级低于导航栏即可 */
		width: 100%;
		padding: 0 2.4vw;
		box-sizing: border-box;
	}

	/* 底部按钮公共样式：宽220 高60 圆角16 文字居中 字体基础配置 统一复用 */
	.bottom-btn {
		width: 29.3333vw;
		/* 精准 220px 宽度 */
		height: 8vw;
		/* 精准 60px 高度 */
		border-radius: 2.1333vw;
		/* 精准 16px 圆角 */
		font-family: SourceHanSansSC-Medium;
		font-size: 3.2vw;
		/* 精准 24px 字号 */
		letter-spacing: 0;
		text-align: center;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	/* 左侧取消按钮：精准匹配所有样式要求 */
	.cancel-btn {
		background: #EBEBED;
		opacity: 0.8;
		color: #666666;
	}

	/* 右侧确定按钮：精准匹配渐变背景+白色文字所有样式要求 */
	.confirm-btn {
		background-image: linear-gradient(114deg, #2FFFB5 0%, #1E89FF 100%);
		color: #FFFFFF;
	}

	.title-with-btn {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.ai-rewrite-btn {
		/* width: 16vw; */
		/* 固定宽120px */
		height: 5.3333vw;
		/* 固定高40px */
		padding: 0.7333vw 2.1333vw;
		/* 上下5.5px 左右16px */
		display: flex;
		align-items: center;
		/* 图片+文字 垂直居中 */
		justify-content: center;
		/* 图片+文字 水平居中 */
		border-radius: 0.8vw;
		/* 加个6px圆角 适配按钮常规设计，可删 */
		box-sizing: border-box;
		opacity: 0.9;
		/* ✅ 新增要求 */
		background: #1570EE;
		/* ✅ 新增要求 */
		border-radius: 2.6667vw;
		/* ✅ 新增要求 20px */
	}

	/* rs.svg 图片样式 宽高24px */
	.rewrite-icon {
		width: 3.2vw;
		height: 3.2vw;
		object-fit: contain;
		/* 防止svg变形 */
		display: block;
	}

	/* 按钮文字样式 */
	.rewrite-text {
		margin-left: 0.5333vw;
		/* 图片右侧4px 不变 */
		font-family: SourceHanSansSC-Regular;
		/* ✅ 指定字体 */
		font-size: 2.6667vw;
		/* ✅ 20px 字号 */
		color: #FFFFFF;
		/* ✅ 白色文字 */
		text-align: center;
		/* ✅ 文字居中 */
		font-weight: 400;
		/* ✅ 常规字重 */
	}

	.required-star {
		width: 2.6667vw;
		/* 20px = 20/7.5 = 2.6667vw */
		height: 2.1333vw;
		/* 16px = 16/7.5 = 2.1333vw */
		margin-right: 0.8vw;
		/* 6px = 6/7.5 = 0.8vw */
		vertical-align: middle;
		/* 与文字水平居中对齐 */
		display: inline-block;
		margin-left: -1.3333vw;
	}

	.topic-title.no-star {
		padding-left: 2.1333vw !important;
		/* 26px = 26/7.5 = 3.4667vw */
	}
</style>